export default "__VITE_ASSET__B18Wgk8U__"